<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">
            <app-filtros-reportes #ctrl [datos]="datos" [cargando]="cargando" ruta="detallado/apartado"></app-filtros-reportes>

            <div style="overflow:auto; height: 85.8vh;">
                <div id="imprimir">
                    <!--Tabla -->
                    <table id class="table is-striped  is-fullwidth" *ngIf="!cargando ">
                        <thead>
                            <tr>
                                <th> Folio</th>
                                <th>Código</th>
                                <th>Fecha</th>
                                <th>Articulos</th>
                                <th>Total Art.</th>
                                <th>Cliente</th>
                                <th>Subtotal</th>
                                <th>Descuento</th>
                                <th>Total</th>
                                <th>Facturado</th>
                                <th>Cajero</th>
                            </tr>
                        </thead>
                        <tbody *ngFor="let item of ctrl.datos; let i=index">
                            <tr>
                                <th> {{ item.folio }}</th>
                                <td>
                                    <strong>{{item.codigo}} </strong>
                                </td>
                                <td>{{ item.created_at | formatoFecha }} </td>
                                <td>{{ item.total_articulos}}</td>
                                <td>{{ item.total_contador}}</td>
                                <td>{{ item.personas?.nombre }}</td>
                                <td>{{ item.subtotal | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</td>
                                <td>{{ item.descuento | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow' }} </td>
                                <td>{{ item.total | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</td>
                                <th>{{ item.facturado > 0 ? 'Si' : 'No'}}</th>
                                <td>{{ item.usuarios?.nombre }}</td>
                            </tr>
                            <tr>
                                <th></th>
                                <td colspan="10">
                                    <table id class="table is-striped  is-fullwidth" *ngIf="!cargando ">
                                        <thead>
                                            <tr>
                                                <th>No.</th>
                                                <th>Clave</th>
                                                <th>Articulo</th>
                                                <th>Cantidad</th>
                                                <th>Precio</th>
                                                <th>Subtotal</th>
                                                <th>Descuento</th>
                                                <th>Importe</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let val of item.movimientos_articulos; let c = index">
                                                <td>{{ c+1 }}</td>
                                                <td>{{ val.articulos?.clave}}</td>
                                                <td>{{ val.articulos?.nombre}}</td>
                                                <td>{{ val.cantidad}}</td>
                                                <td>{{ val.precio_unitario | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</td>
                                                <td>{{ (val.cantidad * val.precio_unitario) | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</td>
                                                <td>{{ val.descuento }} %</td>
                                                <td>{{ val.precio_con_descuentos | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            <tr *ngIf="ctrl.datos.length == 0">
                                <td colspan="5" style="vertical-align: middle; color:#888;">Esta lista está vacía.</td>
                            </tr>
                        </tbody>

                        <tfoot>
                            <tr>
                                <th colspan="6" align="right">
                                    <div align="right">Subtotal</div>
                                </th>
                                <th colspan="5">
                                    <div align="left">{{ctrl.subtotal | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</div>
                                </th>
                            </tr>
                            <tr>
                                <th colspan="6" align="right">
                                    <div align="right">Descuento</div>
                                </th>
                                <th></th>
                                <th colspan="4">
                                    <div align="left">{{ctrl.descuento | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</div>
                                </th>
                            </tr>
                            <tr>
                                <th colspan="6" align="right">
                                    <div align="right">Total</div>
                                </th>
                                <th></th>
                                <th></th>
                                <th colspan="3">
                                    <div align="left">{{ctrl.gran_total | currency:ctrl.configuracion.sucursal.moneda:'symbol-narrow'}}</div>
                                </th>
                            </tr>
                        </tfoot>

                    </table>
                </div>
            </div>
        </div>
    </div>
</div>